import { motion } from "framer-motion";
import { formatCompact } from "@/lib/format";

const StatusBadge = ({ status }) => {
  const map = {
    surplus: { label: "On Track", cls: "bg-[#2D6A4F] text-white" },
    warning: { label: "Cutting It Close", cls: "bg-[#B45309] text-white" },
    depleted: { label: "At Risk", cls: "bg-[#991B1B] text-white" },
  };
  const s = map[status] || map.warning;
  return (
    <span className={`text-xs font-bold px-3 py-1 rounded-full ${s.cls}`} data-testid="status-badge">
      {s.label}
    </span>
  );
};

const Metric = ({ label, value, sub, delay }) => (
  <motion.div
    initial={{ opacity: 0, y: 12 }}
    animate={{ opacity: 1, y: 0 }}
    transition={{ duration: 0.4, delay }}
    className="space-y-1"
  >
    <div className="text-[11px] uppercase tracking-wider font-semibold text-white/50">{label}</div>
    <div className="font-mono text-xl sm:text-2xl font-bold text-white leading-none">{value}</div>
    {sub && <div className="text-xs text-white/60">{sub}</div>}
  </motion.div>
);

export const HeroMetrics = ({ result, currency, planEndAge }) => {
  const lastsLabel =
    result.depletionAge !== null
      ? `Runs out at ${result.depletionAge}`
      : `Lasts through age ${planEndAge}`;

  return (
    <div className="rounded-2xl bg-[#1E2B25] shadow-md overflow-hidden" data-testid="hero-metrics">
      <div className="flex items-center justify-between px-6 pt-5">
        <h2 className="font-heading text-white font-semibold text-lg">Your Retirement Snapshot</h2>
        <StatusBadge status={result.status} />
      </div>
      <div className="grid grid-cols-2 lg:grid-cols-4 gap-5 p-6">
        <Metric label="Corpus at Retirement" value={formatCompact(result.retirementCorpus, currency)}
          sub={`grows @ ${result.preReturn.toFixed(1)}%`} delay={0.05} />
        <Metric label="1st Yr Expense" value={formatCompact(result.firstYearExpense, currency)}
          sub="inflation adjusted" delay={0.1} />
        <Metric label="Withdrawal Rate" value={`${result.swr.toFixed(2)}%`}
          sub={result.swr <= 4 ? "within 4% rule" : "above 4% rule"} delay={0.15} />
        <Metric label="Money Longevity" value={result.depletionAge !== null ? `Age ${result.depletionAge}` : "Full plan"}
          sub={lastsLabel} delay={0.2} />
      </div>
    </div>
  );
};
